/**
 * Character3DHero — the drop-in hero preview for the customization
 * screens (Locker + Character creator).
 *
 * Lazily code-splits {@link Character3DPreview} so Three.js + @tt/shell-3d
 * land in their OWN chunk and stay OUT of the main web bundle — the heavy
 * 3D path only downloads when a player actually opens a screen that shows
 * the live character. Until the chunk resolves (and if WebGL is
 * unavailable, the preview itself falls back internally), the original 2D
 * {@link IconAvatar} is shown, so there is never an empty hole where the
 * character should be.
 *
 * Use THIS, not Character3DPreview directly, from any screen.
 */
import { Suspense, lazy } from 'react';
import { IconAvatar, type IconValue } from './IconAvatar';
import type { Character3DPreviewProps } from './Character3DPreview';

const Character3DPreview = lazy(() => import('./Character3DPreview'));

export function Character3DHero(props: Character3DPreviewProps) {
  const { icon, size = 240, className } = props;
  return (
    <Suspense
      fallback={
        <div
          className={className}
          style={{ width: size, height: size, display: 'grid', placeItems: 'center' }}
        >
          <IconAvatar icon={icon as IconValue} size={size} alt="character preview" />
        </div>
      }
    >
      <Character3DPreview {...props} />
    </Suspense>
  );
}
